import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import { routerShape } from '@bibliocommons/bc-prop-types';
import './SortDropDown.scss';

class SortDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  currentSort() {
    const option = this.props.options.find(sort => sort.get('applied'));

    return option
      ? this.props.intl.formatMessage({
          id: `sort.${option.get('id').toLowerCase()}`
        })
      : this.props.intl.formatMessage({ id: 'sort.relevancy' });
  }

  getOptions() {
    const options = this.props.options.map(option => ({
      key: `sort-dropdown-option-${option.get('id')}`,
      label: this.props.intl.formatMessage({
        id: `sort.${option.get('id').toLowerCase()}`
      }),
      value: option.get('id')
    }));

    return options;
  }

  handleSelect(id) {
    if (this.props.sort) {
      this.props.sort(id);
    } else {
      const { router, paginationField, queryField } = this.props;
      router.push({
        query: {
          ...router.query,
          [queryField]: id,
          [paginationField]: undefined
        }
      });
    }
  }

  render() {
    const { right } = this.props;

    return (
      <span className="cp-sort-dropdown">
        <label htmlFor="sort-dropdown">
          <FormattedMessage id="sort_by" />
        </label>
        <Dropdown
          dataKey="sort-dropdown"
          selected={this.currentSort()}
          options={this.getOptions()}
          handleSelect={this.handleSelect}
          ButtonTag={TextButton}
          className="dropdown-sort"
          right={right}
        />
      </span>
    );
  }
}

SortDropdown.propTypes = {
  options: ImmutablePropTypes.list,
  sort: PropTypes.func,
  right: PropTypes.bool,
  queryField: PropTypes.string,
  paginationField: PropTypes.string,
  router: routerShape.isRequired
};

SortDropdown.defaultProps = {
  paginationField: 'page',
  queryField: 'sort'
};

export default injectIntl(withRouter(SortDropdown));
